import { create } from 'zustand';

import type {
  GlobalAssistantReportParamSuggestion,
  GlobalAssistantReportPrefillMetrics,
} from './global-ai-assistant-api';

type GlobalAssistantReportLaunchPendingState = {
  promotedTemplateId: string | null;
  reportType: string | null;
  paramSuggestions: GlobalAssistantReportParamSuggestion[];
  mwPrefillSuggestions: GlobalAssistantReportParamSuggestion[];
  mwPrefillLaunchSeq: number;
  prefillMetrics: GlobalAssistantReportPrefillMetrics | null;
  launchSeq: number;
};

type GlobalAssistantReportLaunchPendingActions = {
  setPromotedLaunch: (payload: {
    promotedTemplateId: string;
    reportType: string;
    paramSuggestions: GlobalAssistantReportParamSuggestion[];
  }) => void;
  updatePromotedLaunchSuggestions: (
    paramSuggestions: GlobalAssistantReportParamSuggestion[]
  ) => void;
  setMwReportPrefill: (payload: {
    reportType: string;
    paramSuggestions: GlobalAssistantReportParamSuggestion[];
  }) => void;
  bumpMwReportLaunchSeq: () => void;
  clearMwReportPrefill: () => void;
  clearPromotedLaunch: (metrics?: GlobalAssistantReportPrefillMetrics) => void;
};

type GlobalAssistantReportLaunchPendingStore =
  GlobalAssistantReportLaunchPendingState & {
    actions: GlobalAssistantReportLaunchPendingActions;
  };

const initialState: GlobalAssistantReportLaunchPendingState = {
  promotedTemplateId: null,
  reportType: null,
  paramSuggestions: [],
  mwPrefillSuggestions: [],
  mwPrefillLaunchSeq: 0,
  prefillMetrics: null,
  launchSeq: 0,
};

export const useGlobalAssistantReportLaunchPendingStore =
  create<GlobalAssistantReportLaunchPendingStore>((set) => ({
    ...initialState,
    actions: {
      setPromotedLaunch: (payload) =>
        set((state) => ({
          promotedTemplateId: payload.promotedTemplateId,
          reportType: payload.reportType,
          paramSuggestions: payload.paramSuggestions,
          mwPrefillSuggestions: [],
          prefillMetrics: null,
          launchSeq: state.launchSeq + 1,
        })),
      updatePromotedLaunchSuggestions: (paramSuggestions) =>
        set((state) => ({
          ...state,
          paramSuggestions,
          prefillMetrics: null,
        })),
      setMwReportPrefill: (payload) =>
        set((state) => ({
          ...state,
          reportType: payload.reportType,
          mwPrefillSuggestions: payload.paramSuggestions,
          mwPrefillLaunchSeq: state.mwPrefillLaunchSeq + 1,
        })),
      bumpMwReportLaunchSeq: () =>
        set((state) => ({
          ...state,
          mwPrefillLaunchSeq: state.mwPrefillLaunchSeq + 1,
        })),
      clearMwReportPrefill: () =>
        set((state) => ({
          ...state,
          mwPrefillSuggestions: [],
          mwPrefillLaunchSeq: state.mwPrefillLaunchSeq,
        })),
      clearPromotedLaunch: (metrics) =>
        set((state) => ({
          promotedTemplateId: null,
          reportType: null,
          paramSuggestions: [],
          mwPrefillSuggestions: [],
          prefillMetrics: metrics ?? null,
          launchSeq: state.launchSeq,
        })),
    },
  }));

export const globalAssistantReportLaunchPendingStore = {
  getState: useGlobalAssistantReportLaunchPendingStore.getState,
  subscribe: useGlobalAssistantReportLaunchPendingStore.subscribe,
  get actions() {
    return useGlobalAssistantReportLaunchPendingStore.getState().actions;
  },
};
